// extracted by mini-css-extract-plugin
export default {"modal-header":"AddDocument_modal-header__1leuX","modal-header-filter":"AddDocument_modal-header-filter__NwMl0","modal-title":"AddDocument_modal-title__z5zpc"};